export const getHoistedEnums = <T>(values: T[], valueToHoist: T) => {
  const existingValueToHoist = values.find((value) => value === valueToHoist);
  if (!existingValueToHoist) return values;

  return [
    valueToHoist,
    ...values.filter((value) => value !== valueToHoist),
  ];
};

const getHoistedChoices = <T>(choices: { id: T; name: string }[], valueToHoist: T | undefined) => {
  const choiceToHoist = choices.find((choice) => choice.id === valueToHoist);
  if (!choiceToHoist) return choices;

  return [
    choiceToHoist,
    ...choices.filter((choice) => choice.id !== valueToHoist),
  ];
};

export default getHoistedChoices;
